import { useState, useCallback } from 'react';

import { fetchFnsLookupByOgrn } from 'APIPackage/FnsModule/services/fnsLookupApi';

export function useFnsLookupByOgrn() {
  const [isLoading, setIsLoading] = useState(false);

  const getFnsLookupByOgrn = useCallback(async (ogrn: string) => {
    try {
      setIsLoading(true);
      const response = await fetchFnsLookupByOgrn(ogrn);

      return {
        success: true,
        data: response,
      };
    } catch (err) {
      return {
        success: false,
      };
    } finally {
      setIsLoading(false);
    }
  }, []);

  return {
    isLoading,
    getFnsLookupByOgrn,
  };
}
